'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iconButton = require('material-ui/lib/icon-button');

var _iconButton2 = _interopRequireDefault(_iconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BinaryCloseButton = function (_Component) {
  _inherits(BinaryCloseButton, _Component);

  function BinaryCloseButton() {
    _classCallCheck(this, BinaryCloseButton);

    return _possibleConstructorReturn(this, (BinaryCloseButton.__proto__ || Object.getPrototypeOf(BinaryCloseButton)).apply(this, arguments));
  }

  _createClass(BinaryCloseButton, [{
    key: 'getAlignment',
    value: function getAlignment() {
      var _props = this.props,
          right = _props.right,
          left = _props.left;

      var style = {};
      if (right) {
        style.float = 'right';
      }
      if (left) {
        style.float = 'left';
      }
      return style;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          border = _props2.border,
          handleClose = _props2.handleClose;

      var styles = require('./BinaryCloseButton.scss');
      var style = this.getAlignment();
      var className = border ? styles.binary_button_close_border : styles.binary_button_close;
      return _react2.default.createElement(
        'div',
        { style: style, className: className },
        _react2.default.createElement(_iconButton2.default, _extends({}, this.props, {
          children: _react2.default.createElement('i', { className: 'fa fa-close binary_close_btn_icon' }),
          iconClassName: 'fa',
          tooltip: 'Close',
          tooltipStyles: { 'top': '25px' },
          onTouchTap: function onTouchTap() {
            handleClose();
          }
        }))
      );
    }
  }]);

  return BinaryCloseButton;
}(_react.Component);

BinaryCloseButton.propTypes = {
  handleClose: _propTypes2.default.func.isRequired,
  border: _propTypes2.default.bool,
  right: _propTypes2.default.bool,
  left: _propTypes2.default.bool
};
BinaryCloseButton.defaultProps = {
  border: false,
  right: true
};
exports.default = BinaryCloseButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryCloseButton/BinaryCloseButton.js
// module id = 1063
// module chunks = 1